
import { configureStore } from '@reduxjs/toolkit';
import chatsReducer from '../slices/chatsSlice';
import authReducer from '../slices/authSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    chats: chatsReducer,
  },
});

export default store;
